import React from "react";
import PropTypes from "prop-types";
import { wysiwygProp } from "core-web/utils/proptypes/modules/textProps";
import styled from "theme/libs/styled";
import Breadcrumbs from "theme/components/Breadcrumbs";
import TextStyles from "theme/components/text/TextStyles";
import Wysiwyg from "theme/libs/wordpress/components/Wysiwyg";
import Div from "theme/layouts/Div";

const Paragraph = styled("div")`
    max-width: 515px;
`;

const validTags = ["url", "i", "b", "u", "ul", "ol", "li", "span"];

const PageIntroBlock = ({ breadcrumbs, headingText, paragraph, paragraphFallback }) => {
    return (
        <Div pt={["48px", null, null, null, "64px"]} pb={["24px", null, null, null, "80px"]}>
            {breadcrumbs?.length > 0 && <Breadcrumbs isUnderneathNavbar breadcrumbs={breadcrumbs} />}
            <TextStyles
                as="h1"
                textStyles={["Myriad Pro/40-120-semibold", null, null, null, "Myriad Pro/64-110-semibold"]}
                maxWidth="875px"
                mt={["48px", null, null, null, "64px"]}
            >
                {headingText}
            </TextStyles>
            <Paragraph m="24px 0 0">
                {paragraph?.length > 0 ? (
                    <Wysiwyg
                        data={paragraph}
                        textComponent={(props) => (
                            <TextStyles
                                textStyles={["Myriad Pro/18-140", null, null, null, "Myriad Pro/20-140"]}
                                display="block"
                                {...props}
                            />
                        )}
                        validTags={validTags}
                    />
                ) : (
                    paragraphFallback && (
                        <TextStyles
                            textStyles={["Myriad Pro/18-140", null, null, null, "Myriad Pro/20-140"]}
                            display="block"
                        >
                            {paragraphFallback}
                        </TextStyles>
                    )
                )}
            </Paragraph>
        </Div>
    );
};

PageIntroBlock.propTypes = {
    breadcrumbs: PropTypes.arrayOf(PropTypes.object),
    headingText: PropTypes.string,
    paragraph: wysiwygProp,
    paragraphFallback: PropTypes.string,
};

PageIntroBlock.defaultProps = {
    breadcrumbs: [],
    headingText: "",
    paragraph: null,
    paragraphFallback: null,
};

export default PageIntroBlock;
